import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { Box, Button, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Classification, Locale, Participant } from "../../core/api/model";
import CustomIcon from "../../core/custom-icon";

export interface DashboardClassificationsListAddProps {
  locale: Locale;
  classifications: Classification[];
  experts: Participant[];
  cancel: () => void;
  confirm: (classificationId: number, partId: number) => void;
}

interface ExpertAddForm {
  classificationId: number;
  partId: number;
}

export const DashboardClassificationsListAdd = (props: DashboardClassificationsListAddProps) => {
  
  const intl = useIntl();

  const { handleSubmit } = useForm<ExpertAddForm>();
  
  const onSubmit = (data: ExpertAddForm) => {
    if (! selectedClassification.classificationId || ! selectedExpert.partId) {
      return
    }
    props.confirm(selectedClassification.classificationId, selectedExpert.partId);
  }

  const [selectedClassification, setSelectedClassification] = React.useState<Partial<Classification>>({});
  const [selectedExpert, setSelectedExpert] = React.useState<Partial<Participant>>({});

  return (
    <Box bgcolor='secondary.main'
         color='common.white'
         px={{xs: 2, md: 3}}
         pb={{xs: 2, md: 3}}
    >
      <Box textAlign='right' mr={{xs: -2, md: -3}}>
        <Button onClick={props.cancel}
                color='secondary'
                endIcon={
                  <CustomIcon iconname='erase' />
                }
        >
          <FormattedMessage id='DashboardClassificationsAddCancel' />
        </Button>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography component='h3' variant='h4'>
          <FormattedMessage id='DashboardClassificationsAddClassificationTitle' />
        </Typography>
        <Autocomplete
          classes={{
            popupIndicator: 'form--white'
          }}
          disableClearable
          options={props.classifications || []}
          getOptionLabel={(classification: Partial<Classification>) => classification?.classificationTitle ? classification?.classificationTitle[props.locale] : ''}
          value={selectedClassification}
          onChange={(event, value) => { 
            setSelectedClassification(value);
          }}
          renderInput={(props) => <TextField {...props} variant="standard" margin='normal' InputLabelProps={{className: 'form--white'}} InputProps={{...props.InputProps, className: 'form--white'}} className='form--white' label={intl.formatMessage({id: 'DashboardClassificationsAddClassificationLabel'})} />}
        />
        <Box mt={{xs: 2.25, md: 4}} mb={{}}>
          <Typography component='h3' variant='h4'>
            <FormattedMessage id='DashboardClassificationsAddExpertTitle' />
          </Typography>
        </Box>
        <Autocomplete
          classes={{
            popupIndicator: 'form--white'
          }}
          disableClearable
          options={props.experts || []}
          getOptionLabel={(expert: Partial<Participant>) => expert?.partName || expert?.partSurname ? `${expert?.partName} ${expert?.partSurname}` : ''}
          value={selectedExpert}
          onChange={(event, value) => { 
            setSelectedExpert(value);
          }}
          renderInput={(props) => <TextField {...props} variant="standard" margin='normal' InputLabelProps={{className: 'form--white'}} InputProps={{...props.InputProps, className: 'form--white'}} className='form--white' label={intl.formatMessage({id: 'DashboardClassificationsAddExpertLabel'})} />}
        />

        <Box textAlign='right' mt={2}>
          <Button type='submit' className='button--white'>
            <FormattedMessage id='DashboardClassificationsAddConfirm' />
          </Button>
        </Box>
      </form>
    </Box>
  );
};
